export const policyTemplatesQueryKeys = {
    all: ['policy-templates'] as const,
    categories: () => [...policyTemplatesQueryKeys.all, 'categories'] as const,
    risks: () => [...policyTemplatesQueryKeys.all, 'risks'] as const
} as const;
